var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkin__child-course checkin-box",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"contents-wrapper"},[_vm._t("default")],2),_c('div',{staticClass:"right-arrow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }